<style lang="scss" scoped>
.rte {
    @media (min-width: 1024px) {
        ::v-deep {
            h1,
            h2,
            h3,
            h4,
            h5 {
                font-size: 100%;
            }
        }
    }
    ::v-deep h1 {
        @apply text-title-lg font-extraBold text-white;
        letter-spacing: -2.41px;
    }
    ::v-deep h2 {
        @apply text-title-md font-extraBold text-white;
        letter-spacing: -1.16px;
    }
    ::v-deep h3 {
        @apply text-34 font-extraBold text-white;
        letter-spacing: -0.58px;
        margin-bottom: 24px;
    }
    ::v-deep h4 {
        @apply text-24 font-extraBold text-white;
        letter-spacing: -0.58px;
        margin-bottom: 24px;
    }
    ::v-deep h5 {
        @apply text-18 font-extraBold text-white;
        letter-spacing: -0.58px;
        margin-bottom: 24px;
    }
    ::v-deep p {
        @apply text-18 text-gray;
        letter-spacing: -0.43px;
    }
    ::v-deep ol,
    ::v-deep ul {
        @apply text-18 text-gray;
        list-style: disc;
        margin: 18px 0;
        padding: 0 0 0 20px;
    }
    ::v-deep th {
        @apply text-24 text-white;
        border: 1px solid white;
        padding: 16px;
    }
    ::v-deep td {
        @apply text-gray;
        border: 1px solid white;
        padding: 16px;
    }
    ::v-deep table {
        margin-top: 40px;
        text-align: left;
        border: 1px solid white;
        padding: 16px;
    }
}
</style>

<template>
    <section class="container">
        <div class="grid grid-cols-12 gap-30">
            <div class="hidden lg:block col-span-2"></div>
            <div class="col-span-12 lg:col-span-8">
                <div class="rte" v-html="data.content"></div>
            </div>
            <div class="hidden lg:block col-span-2"></div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        }
    }
};
</script>
